import React from 'react';
import { NewGenericEventModalContextProvider } from './NewGenericEventModalContext';
import NewGenericEventModal from './nested/modal';
import './styles.scss';
function NewGenericEventModalWrapper(params) {
    return (React.createElement(NewGenericEventModalContextProvider, { onClose: params.onClose, onSave: params.onSave },
        React.createElement(NewGenericEventModal, { eventType: params.eventType })));
}
export default NewGenericEventModalWrapper;
